import { render, staticRenderFns } from "./MaxLengthInput.vue?vue&type=template&id=a5b72846&scoped=true"
import script from "./MaxLengthInput.vue?vue&type=script&lang=js"
export * from "./MaxLengthInput.vue?vue&type=script&lang=js"
import style0 from "./MaxLengthInput.vue?vue&type=style&index=0&id=a5b72846&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b72846",
  null
  
)

export default component.exports